import React from 'react';

import './styles.scss';

const DPSceneHs = ({ data, onClickHotspot }) => {
  return (
    <div className="circle-container">
      <div className="circle" onClick={onClickHotspot}></div>
    </div>
  );
};

export default DPSceneHs;
